const GET_PROFILE_WALL_POSTS_REQUEST = 'GET_PROFILE_WALL_POSTS_REQUEST';
const GET_PROFILE_WALL_POSTS_SUCCESS = 'GET_PROFILE_WALL_POSTS_SUCCESS';
const GET_PROFILE_WALL_POSTS_FAILURE = 'GET_PROFILE_WALL_POSTS_FAILURE';

import {WALL_MATERIAL_LIKE_SUCCESS} from 'reducers/wallMaterial';

import * as backend from 'backend-helpers/profileWallPosts';
import {BobTVUser} from 'bobtvuser';

const initState = {
    user: null,
    online: null,
    wallMaterials: {
        list: [],
        totalCount: 0
    }
};

export default function profileWallPosts(state = initState, action) {
    if (action.type === GET_PROFILE_WALL_POSTS_SUCCESS) {
        let {status, user, ...rest} = action.result;

        return {
            ...state,
            ...rest,
            user: new BobTVUser(user)
        }
    }

    if (action.type === GET_PROFILE_WALL_POSTS_FAILURE) {
        let {error, ...rest} = action;

        console.log('GET_PROFILE_WALL_POSTS_FAILURE:', error);

        return {
            ...state,
            user: new BobTVUser({_loaded: false, _notFound: true})
        }
    }

    if (action.type === WALL_MATERIAL_LIKE_SUCCESS) {
        let {like_count} = action.result;

        return {
            ...state,
            wallMaterials: {
                ...state.wallMaterials,
                list: state.wallMaterials.list.map((wallMaterial) => action.id === wallMaterial.id ? {
                    ...wallMaterial,
                    like_count
                } : wallMaterial)
            }
        }
    }

    return state;
}

export function getProfileWallPosts(nick) {
    return {
        types: [GET_PROFILE_WALL_POSTS_REQUEST, GET_PROFILE_WALL_POSTS_SUCCESS, GET_PROFILE_WALL_POSTS_FAILURE],
        promise: backend.getProfileWallMaterials(nick)
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profileWallPosts.js